import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function HotArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-50" id="hot">
      <div className="w-full px-4 md:px-6">
        {/* Section Header */}
        <div className="mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            今日吃瓜热门大瓜
          </h2>
          <p className="text-foreground-500 text-sm">
            全网最新最热的八卦爆料，每日持续更新中
          </p>
        </div>

        {/* Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {articles.slice(0, 6).map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-background-300/60 transition-all duration-300 cursor-pointer ${
                article.isHot && idx === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              {/* Image */}
              <div className={`relative overflow-hidden ${article.isHot && idx === 0 ? 'h-72' : 'h-48'}`}>
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {/* Hot Badge */}
                {article.isHot && (
                  <div className="absolute top-3 left-3 flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium">
                    <i className="ri-fire-line text-xs"></i>
                    <span>热门</span>
                  </div>
                )}
                {/* Category Tag */}
                <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-background-950/70 backdrop-blur-sm text-background-50 text-xs">
                  {article.category}
                </div>
              </div>

              {/* Content */}
              <div className="p-4 md:p-5">
                {/* Title */}
                <h3 className={`font-heading font-bold text-foreground-950 leading-snug mb-3 group-hover:text-primary-600 transition-colors ${
                  article.isHot && idx === 0 ? 'text-xl md:text-2xl' : 'text-base md:text-lg'
                }`}>
                  {article.title}
                </h3>

                {/* Excerpt */}
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>

                {/* Meta */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2 text-foreground-400 text-xs">
                    <i className="ri-eye-line"></i>
                    <span>{article.heat > 10000 ? `${(article.heat / 10000).toFixed(1)}万` : article.heat.toLocaleString()} 热度</span>
                  </div>
                  <span className="text-foreground-400 text-xs">{article.publishDate}</span>
                </div>

                {/* Read Button */}
                <div className="mt-3">
                  <span className={`inline-flex items-center gap-1.5 px-5 py-2 rounded-full text-xs font-medium transition-all duration-200 ${
                    article.isHot && idx === 0
                      ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                      : 'border border-foreground-300 text-foreground-700 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950'
                  }`}>
                    阅读全文
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View More */}
        <div className="text-center mt-10">
          <Link
            to="/category/star-collapse"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-medium hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            查看更多大瓜
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}